import { ChangeEvent, KeyboardEvent, useCallback } from 'react';
import styled from '@emotion/styled';

import { keyboardButtons } from '@selfserve/react-utils';

import { StyledInput } from './styled-components';

const StyledContainer = styled.div`
  position: relative;
`;

const StyledRoomCountInput = styled(StyledInput)`
  max-width: 100px;
`;

const StyledIncrementButton = styled.button`
  position: absolute;
  cursor: pointer;
  padding: 0;
  top: 7px;
  right: 9px;
  border: 0;
  background: 0;
`;

const StyledDecrementButton = styled(StyledIncrementButton)`
  top: initial;
  bottom: 7px;
`;

const StyledIcon = styled('span', {
  shouldForwardProp: () => false,
})(({ rotate }: { rotate?: boolean }) => ({
  display: 'block',
  width: '15px',
  height: '12px',
  background: 'no-repeat url("assets/arrow.svg") center',
  backgroundSize: '56%',
  ...(rotate && {
    transform: 'rotate(180deg)',
  }),
}));

interface Props {
  id: string;
  value: number | string;
  name: string;
  onChange: (name: string, value: string | number) => void;
}

export const InputCounter = ({ onChange, ...rest }: Props) => {
  const handleIncrement = useCallback(() => {
    onChange(rest.name, String(+rest.value + 1));
  }, [rest]);

  const handleDecrement = useCallback(() => {
    if (+rest.value > 1) {
      onChange(rest.name, String(+rest.value - 1));
    }
  }, [rest]);

  const onChangeHandle = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    if (+value) onChange(rest.name, value || '1');
  }, []);

  const onkeydownHandle = useCallback(
    (event: KeyboardEvent<HTMLInputElement>) => {
      if (event.code === keyboardButtons.UP) {
        event.preventDefault();
        handleIncrement();
      }
      if (event.code === keyboardButtons.DOWN) {
        event.preventDefault();
        handleDecrement();
      }
    },
    [handleIncrement, handleDecrement]
  );

  return (
    <StyledContainer>
      <StyledRoomCountInput
        {...rest}
        onChange={onChangeHandle}
        onKeyDown={onkeydownHandle}
        inputProps={{ 'aria-valuenow': +rest.value }}
      />
      <span>
        <StyledIncrementButton className="button-up" onClick={handleIncrement}>
          <StyledIcon />
        </StyledIncrementButton>
      </span>
      <span>
        <StyledDecrementButton
          className="button-down"
          onClick={handleDecrement}
        >
          <StyledIcon rotate />
        </StyledDecrementButton>
      </span>
    </StyledContainer>
  );
};
